import { Controller } from "@hotwired/stimulus"
import DirectoryTable from "../lib/directory_table"
import { DateTime } from "luxon"
import { emptyStatePlaceholder } from "./tabulator_helpers"

export default class extends Controller {
  static targets = ["table"]

  static values = {
    url: String,
    filtered: Boolean,
    tabulatorTable: Object,
  }

  connect() {
    let ajaxUrl = this.urlValue
    try {
      const u = new URL(this.urlValue, window.location.origin)
      u.searchParams.set("format", "json")
      ajaxUrl = u.toString()
    } catch (e) {}

    this.tabulatorTable = new DirectoryTable(this.tableTarget, {
      layout: "fitDataStretch",
      placeholder: emptyStatePlaceholder(
        this.filteredValue ? "No events match these filters" : "No audit events yet"
      ),
      // Both bounds make the table fit its rows, so a short page does not leave
      // an empty band between the last row and the pager.
      minHeight: 240,
      maxHeight: "calc(100vh - 250px)",
      ajaxURL: ajaxUrl,
      ajaxConfig: "GET",
      pagination: true,
      paginationMode: "remote",
      paginationSize: 50,
      paginationCounter: "rows",
      paginationSizeSelector: [50, 100, 300],
      dataSendParams: { page: "page", size: "length" },
      ajaxResponse: (url, params, response) => ({
        data: response.data,
        last_page: response.last_page,
        last_row: response.last_row,
      }),
      columnDefaults: { headerSort: false },
      columns: [
        {
          title: "Timestamp",
          field: "occurred_at",
          formatter: "datetime",
          formatterParams: {
            inputFormat: "iso",
            outputFormat: "MMM d, yyyy 'at' t",
            invalidPlaceholder: "—",
            timezone: "America/Los_Angeles",
          },
        },
        { title: "User", field: "user_name" },
        { title: "Event type", field: "event_type" },
        {
          title: "Process",
          field: "process_reference",
          formatter: (cell) => {
            const value = cell.getValue()
            const url = cell.getRow().getData().process_url
            if (!value || !url) return "—"
            return `<a href="${url}" class="link">${value}</a>`
          },
        },
        {
          title: "Task",
          field: "task_reference",
          formatter: (cell) => {
            const value = cell.getValue()
            const url = cell.getRow().getData().task_url
            if (!value || !url) return "—"
            return `<a href="${url}" class="link">${value}</a>`
          },
        },
        {
          title: "API Client",
          field: "api_client",
          formatter: (cell) => cell.getValue() || "—",
        },
        { title: "Summary", field: "summary_text", widthGrow: 2 },
        {
          title: "Details",
          field: "details",
          widthGrow: 2,
          formatter: (cell) => cell.getValue() || "—",
        },
      ],
      dependencies: {
        DateTime: DateTime,
      },
    })
  }

  disconnect() {
    this.tabulatorTable?.destroy()
    this.tabulatorTable = null
  }
}
